import { render, staticRenderFns } from "./timeConfig.vue?vue&type=template&id=8d21a4c6&"
import script from "./timeConfig.vue?vue&type=script&lang=js&"
export * from "./timeConfig.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports